import { render, staticRenderFns } from "./recordsModal.vue?vue&type=template&id=af94019a&"
import script from "./recordsModal.vue?vue&type=script&lang=ts&"
export * from "./recordsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports